var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "editor-controller" },
    [
      _c("div", { staticClass: "insert-symbol" }, [
        _c("div", { staticClass: "icon-box", on: { click: _vm.brackets } }, [
          _c("div", [
            _vm._v(_vm._s(_vm.$t("editorController.symbols.brackets"))),
          ]),
        ]),
        _c("div", { staticClass: "icon-box", on: { click: _vm.ellipsis } }, [
          _c("div", [
            _vm._v(_vm._s(_vm.$t("editorController.symbols.ellipsis"))),
          ]),
        ]),
        _c("div", { staticClass: "icon-box", on: { click: _vm.space } }, [
          _c("img", {
            attrs: {
              src: require("@/assets/img/icon/space_bar.svg"),
              alt: "space bar",
            },
          }),
        ]),
        _c("div", { staticClass: "icon-box", on: { click: _vm.dash } }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("editorController.symbols.dash")))]),
        ]),
        _vm.showRuby
          ? _c("div", { staticClass: "icon-box", on: { click: _vm.ruby } }, [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("editorController.symbols.ruby"))),
              ]),
            ])
          : _vm._e(),
        _vm.showEmphasisMark
          ? _c(
              "div",
              { staticClass: "icon-box", on: { click: _vm.emphasisMark } },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("editorController.symbols.emphasisMark"))
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm.showSearchReplace || _vm.showUndoRedo
        ? _c(
            "div",
            { staticClass: "undo-redo" },
            [
              _vm.showSearchReplace
                ? _c(
                    "div",
                    {
                      staticClass: "icon-box",
                      on: { click: _vm.toggleEnabledSearchReplace },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("editorController.actions.searchReplace")
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.showUndoRedo
                ? [
                    _c(
                      "div",
                      { staticClass: "icon-box", on: { click: _vm.undo } },
                      [
                        _c("div", { staticClass: "icon-text" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icon/undo.svg"),
                              alt: "undo",
                            },
                          }),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("editorController.actions.undo"))
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "icon-box", on: { click: _vm.redo } },
                      [
                        _c("div", { staticClass: "icon-text" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/icon/redo.svg"),
                              alt: "redo",
                            },
                          }),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("editorController.actions.redo"))
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.showSearchReplace && _vm.enabledSearchReplace
        ? _c("SearchReplaceDialog", { staticClass: "dialog" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }